import { render, staticRenderFns } from "./UpdateBillingProfile.vue?vue&type=template&id=5df4770c"
import script from "./UpdateBillingProfile.vue?vue&type=script&lang=js"
export * from "./UpdateBillingProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports